import {
	Box,
	Button,
	DialogActions,
	DialogContent,
	DialogContentText,
	TextField,
	Typography
} from "@mui/material"
import {
	closeAttachmentModal,
	editNoteAttachment,
	postNoteFileAttachment, selectActionType,
	selectIsNoteAttachmentPreviewValid,
	selectNoteAttachmentPreview,
	updateNoteAttachmentPreview,
	patchNoteFileAttachment, selectIsSubmitting
} from "../../../../../../reducers/noteAttachmentsSlice"
import Attachment from "../../NoteAttachment/Attachment"
import {useDispatch, useSelector} from "react-redux"
import {useMemo, useState} from "react"
import {formatBytes} from "../../../../../../utils/noteUtilities"
import mime from "mime"
import FileDropzone from "../NoteAttachmentFileDropzone"
import {useWorkspaceContext} from "../../../../../../pages/Dashboard"

export function FileAttachmentModalBody({note}) {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const attachmentPreview = useSelector((state) => selectNoteAttachmentPreview(state, workspaceId))
	const isAttachmentValidSelector = useMemo(() => selectIsNoteAttachmentPreviewValid(workspaceId), [workspaceId])
	const isAttachmentValid = useSelector(isAttachmentValidSelector)
	const isSubmitting = useSelector((state) => selectIsSubmitting(state, workspaceId))
	const actionType = useSelector((state) => selectActionType(state, workspaceId))
	const [fileToBeUploaded, setFileToBeUploaded] = useState(null)

	const handleFileInputChange = (event) => {
		const file = event.target.files[0]
		const fileSizeHumanReadable = formatBytes(file.size)
		const fileTypeHumanReadable = mime.getExtension(file.type)
		// if the user has entered a custom title BEFORE UPLOADING A FILE, do not overwrite it with the file's filename:
		const userInputTitle = ((attachmentPreview.title !== "") && (attachmentPreview.title.length > 0))
		const newPreview = {
			...attachmentPreview,
			title: userInputTitle ? attachmentPreview.title : file.name,
			description: `Size: ${fileSizeHumanReadable} \n File Type: ${fileTypeHumanReadable} \n File Name: ${file.name} \n`,
			fileName: file.name,
			fileType: file.type,
		}
		dispatch(updateNoteAttachmentPreview({preview: newPreview, workspaceId}))
		setFileToBeUploaded(file)
	}

	return (
		<DialogContent>
			<DialogContentText variant="body1" sx={{color: "black"}} paragraph gutterBottom>
				{
					actionType === "create-file" && (
						`Attach a file to the note: ${note?.content}`
					)
				}
				{
					actionType === "edit-file" && (
						`Change the file currently attached to the note: ${note?.content}`
					)
				}
			</DialogContentText>
			<form onSubmit={(e) => {
				e.preventDefault()
				if (actionType === "create-file") {
					const attachmentAsFormData = new FormData()

					//fileObject will be passed through Express Multer as a file
					attachmentAsFormData.append("fileObject", fileToBeUploaded)
					//everything else will append to the request body despite being transformed into formData here
					for (const [key, value] of Object.entries(attachmentPreview)) {
						attachmentAsFormData.append(key, value)
					}
					dispatch(postNoteFileAttachment({attachment: attachmentAsFormData, note }))
				}
				if (actionType === "edit-file") {
					if(fileToBeUploaded) {
						const newAttachmentAsFormData = new FormData()
						newAttachmentAsFormData.append("fileObject", fileToBeUploaded)
						for (const [key, value] of Object.entries(attachmentPreview)) {
							newAttachmentAsFormData.append(key, value)
						}
						dispatch(patchNoteFileAttachment({
							attachment: newAttachmentAsFormData,
							note,
							attachmentId: attachmentPreview.id
						}))
					} else {
						dispatch(editNoteAttachment({attachment: attachmentPreview, note }))
					}
				}
			}}>
				<FileDropzone handleFileInputChange={handleFileInputChange} />
				<TextField
					variant="outlined"
					label={"Title"}
					className="keyTextField"
					value={attachmentPreview?.title || attachmentPreview?.fileName}
					onChange={(e) => dispatch(updateNoteAttachmentPreview({preview: {...attachmentPreview, title: e.target.value}, workspaceId}))}
					sx={{
						mt: 3, // shorthand for marginTop: theme.spacing(2)
						mb: 1, // shorthand for marginBottom: theme.spacing(2)
					}}
					fullWidth
					required
				/>
				<Box sx={{
					mt: 0,
					mb: 1
				}}>
					<Typography variant="subtitle1" component="div">
						Preview
					</Typography>
					<Attachment attachment={attachmentPreview} preview={true} />
				</Box>
				<DialogActions
					sx={{
						padding: 0,
						mt: 2
					}}
				>
					<Button
						variant="contained"
						color={"primary"}
						type="submit"
						disabled={isSubmitting || !isAttachmentValid}
					>
						{ actionType === "create-file" && "Attach File" }
						{ actionType === "edit-file" && "Modify File" }
					</Button>
					<Button
						variant={"outlined"}
						color="primary"
						onClick={() => dispatch(closeAttachmentModal(workspaceId))}
					>
						Cancel
					</Button>
				</DialogActions>
			</form>
		</DialogContent>
	)
}